module.exports = __webpack_public_path__ + "img/bannerLogin.c16ad786.png";